import moment from "moment";

const getAge = (dateOfBirth: string): number =>
  moment().diff(moment(dateOfBirth, "YYYY-MM-DD", true), "years");

export default getAge;
